<style scoped>
  .update-settings-modal-btn[tabindex]:focus {
    outline: 2px solid blue;
    outline: 5px auto -webkit-focus-ring-color;
  }
</style>
<template>
  <FocusTrap v-model="showModal">
    <div id='select-language-component' class='settings-side-nav-bottom'>
      <photo-stream-modal
        id="select-language-modal"
        v-if='showModal'
        v-on:close="closeModal"
      >
        <template #header>
          <h2 tabindex="0" class="select-language-component-title" ref="languageHeader">{{ lang.get('event_strings.settings_modal.language_title') }}</h2>
        </template>
        <template #body>
          <div v-if="fetching" class="text-center pt-3">
            <i class="far fa-4x fa-spin fa-spinner"></i>
            <div class="status-message" v-html="message"></div>
          </div>
          <div id='form-body' class='form-group' v-if="!fetching">
            <label class="hide" for="select-language-input" tabindex="0">Select Language</label>
            <searchable-dropdown 
              v-model="currentLanguage" 
              v-bind:options="validLanguages" 
              v-bind:default-option="lang.get('event_strings.settings_modal.language_select_placeholder')"
              input-id="select-language-input"
              input-tabindex="0"
            ></searchable-dropdown>
            <button role="button" tabindex="0" class='btn btn-primary update-settings-modal-btn' :aria-label="lang.get('event_strings.update_button')" @click='updateLanguage' >
              {{ lang.get('event_strings.update_button') }}
            </button>
          </div>
        </template>
      </photo-stream-modal>
    </div>
  </FocusTrap>
</template>

<script>
import SearchableDropdown from '../../components/global/SearchableDropdown'
import { FocusTrap } from 'focus-trap-vue'

export default {

  components: {
    SearchableDropdown,
    FocusTrap
  },

  data() {
    return {
      validLanguages: [],
      currentLanguage: null,
      message: '',
      showModal: false,
      fetching: false
    }
  },
  methods:  {

    openModal: function () {
      this.message = ''
      if (!this.fetching) this.fetchLanguages()
      this.showModal =  true
      this.$nextTick(() => this.$refs.languageHeader.focus())
    },

    closeModal: function () {
      this.showModal = false
      this.message = ''
    },
    
    fetchLanguages: function () {
      this.fetching = true
      axios.get('/languages').then((res) => {
        this.validLanguages = res.data.languages.map(function (lang) {
          return { value: lang.enum_value, text: lang.enum_key }
        })
        this.currentLanguage = res.data.language
      }).catch((err) => {
        console.error('error fetching languages')
        this.message = '<h4 class="text-danger">'+ this.lang.get('event_strings.settings_modal.language_loading_error') +'</h4>'
      }).finally(() => {
        this.fetching = false
      })
    },

    updateLanguage: function () {
      var languageName = '<i>'+this.selectedLanguageLabel+'<i>';
      this.message = '<h4>' + this.lang.get('event_strings.settings_modal.updating_language_text', {'language' : languageName}) + '</h4>'
      this.fetching = true
      axios.post('/update_attendee_settings', {
        language: this.currentLanguage
      }).then((res) => {
        this.message = '<h4>'+ this.lang.get('event_strings.settings_modal.updated_language_text', {'language' : languageName}) +'<br>'+ this.lang.get('event_strings.settings_modal.reloading_page_msg')+'</h4>'
        window.location.reload()
      }).catch((err) => {
        console.log(err)
        this.message = '<h4 class="text-danger">'+ this.lang.get('event_strings.settings_modal.language_saving_error')+'</h4>'
        this.fetching = false
      })
    }
  },

  computed: {
      selectedLanguageLabel: function () {
        var language = this.validLanguages.find(lang => lang.value == this.currentLanguage)
        if (language) {
          return language.text
        } else {
          return ''
        }
      }
  },

  mounted () {
    window.selectLanguageOpen = this.openModal
  }
};
</script>

<style>
  #select-language-modal .modal-body {
    height: 250px;
  }
  #select-language-modal .search-list ul li { 
    font-size: 13px;
  }
</style>

<style scoped>
  .status-message {
    padding-top: 30px;
  }
  #form-body {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  #select-language-component {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .open-modal-btn {
    display: flex
  }

  select.form-control  {
    height: unset !important;
  }
</style>